import React from 'react';
import PropTypes from 'prop-types';
// MaterialUI
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
//
import IttAppBar from '../app/IttAppBar';

PageLoadingIndicator.propType = {
  title: PropTypes.string,
};

function PageLoadingIndicator({ title }) {
  return (
    <>
      <IttAppBar title={title} />
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <CircularProgress color="warning" />
      </Box>
    </>
  );
}

export default PageLoadingIndicator;
